import React from 'react';
import AiNotesPanel from '../../../ai-notes/components/web/AiNotesPanel';
import Chat from '../../../chat/components/web/Chat';
import ClosedCaptionsTab from '../../../chat/components/web/ClosedCaptionsTab';
import CustomPanel from '../../../custom-panel/components/web/CustomPanel';
import FileSharing from '../../../file-sharing/components/web/FileSharing';
import ParticipantsPane from '../../../participants-pane/components/web/ParticipantsPane';
import PollsPane from '../../../polls/components/web/PollsPane';
import { SidePanelEmbedContext } from '../../SidePanelEmbedContext';
import { SidePanelTabId } from '../../constants';
/**
 * Renders the body of a side panel tab inside docked or floating chrome.
 *
 * @param {IProps} props - Props.
 * @returns {JSX.Element | null}
 */
export default function SidePanelTabContent({ tabId, surface }) {
    let content = null;
    switch (tabId) {
        case SidePanelTabId.CHAT:
            content = React.createElement(Chat, null);
            break;
        case SidePanelTabId.PARTICIPANTS:
            content = React.createElement(ParticipantsPane, null);
            break;
        case SidePanelTabId.AI_NOTES:
            content = React.createElement(AiNotesPanel, null);
            break;
        case SidePanelTabId.CUSTOM_PANEL:
            content = React.createElement(CustomPanel, null);
            break;
        case SidePanelTabId.POLLS:
            content = (React.createElement("div", { style: { height: '100%' } },
                React.createElement(PollsPane, null)));
            break;
        case SidePanelTabId.CLOSED_CAPTIONS:
            content = (React.createElement("div", { style: { height: '100%' } },
                React.createElement(ClosedCaptionsTab, null)));
            break;
        case SidePanelTabId.FILE_SHARING:
            content = (React.createElement("div", { style: { height: '100%' } },
                React.createElement(FileSharing, null)));
            break;
        default:
            return null;
    }
    return (React.createElement(SidePanelEmbedContext.Provider, { value: {
            embedded: true,
            surface
        } }, content));
}
